import React from 'react';

const MongoDB_lookup_out = () => {
  return (
    <div>
      <h1>MongoDB_lookup_out Component</h1>
      <p>This is the MongoDB_lookup_out page.</p>
    </div>
  );
};

export default MongoDB_lookup_out;
